export const CURR_YEAR = 2024;
